type Props = {
  className?: string
}

export const IconMapSearchPinClicked = ({ className }: Props) => {
  return (
    <svg
      className={className}
      fill="none"
      height="87"
      viewBox="0 0 63 87"
      width="63"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M51.7563 53.6632C51.8233 53.5667 51.8782 53.4634 51.9204 53.3558C53.0487 51.7254 54.2812 49.9293 55.7111 47.837C58.2038 44.1965 61.191 38.2572 60.9904 30.8957C60.7089 20.3253 54.6374 13.0872 52.7735 11.106C50.6751 8.86908 42.8481 1.5 31.4774 1.5C20.1031 1.5 12.3195 8.87385 10.225 11.1069C8.36012 13.0893 2.29041 20.3269 2.00889 30.8957L2.00888 30.8961C1.85504 36.73 3.70284 42.587 7.28717 47.8355C7.29311 47.8442 7.29915 47.8528 7.30527 47.8614L7.35162 47.9263C11.3368 53.7652 13.7848 57.3367 16.8732 61.3347L16.8742 61.336C21.4947 67.3041 24.9022 74.7444 26.9469 83.4672C26.9608 83.6131 26.9963 83.7585 27.0543 83.8985C27.2863 84.4592 27.8334 84.8248 28.4402 84.8248H34.5925C35.2898 84.8248 35.8952 84.3443 36.0534 83.6651C38.1047 74.8599 41.5172 67.3566 46.1696 61.3472L46.1738 61.3418C47.9473 59.0294 49.5745 56.8072 51.7563 53.6632Z"
        fill="white"
        stroke="#DA476A"
        strokeLinejoin="round"
        strokeWidth="3"
      />
      <path
        d="M31.4763 45.6212C24.5675 45.6212 18.9492 40.003 18.9492 33.0941C18.9492 26.1853 24.5675 20.567 31.4763 20.567C38.3852 20.567 44.0034 26.1853 44.0034 33.0941C44.0034 40.003 38.3852 45.6212 31.4763 45.6212Z"
        fill="#DA476A"
      />
    </svg>
  )
}
